import axios from 'axios'

import {
  orderBy,
  isBooleand,
  compareArrangementWith,
} from '~/plugins/helper'
import * as types from '../mutation-types'

// state
export const state = {
  loadingNotifications: true,
  errorNotifications: null,
  notifications: [],

  newNotification: null,

  loading: true,
  resultAssignmentSelectionDate: null,
  error: null,
}

// mutations
export const mutations = {
  [types.GET_NOTIFICATIONS_START](state) {
    state.loadingNotifications = true
    state.errorNotifications = null
    state.notifications = []
  },
  [types.GET_NOTIFICATIONS_SUCCESS](state, { notifications, data }) {
    state.loadingNotifications = false
    state.errorNotifications = null
    notifications = compareArrangementWith(notifications, data, false)
    state.notifications = orderBy(notifications, ['id'], ['desc'])
  },
  [types.GET_NOTIFICATIONS_ERROR](state, { error }) {
    state.loadingNotifications = false
    state.errorNotifications = error
    state.notifications = []
  },

  [types.GET_EVENT](state, payload) {
    state.newNotification = payload
  },

  [types.ASSIGN_SELECTION_DATE_START](state) {
    state.loading = true
    state.resultAssignmentSelectionDate = null
    state.error = null
  },
  [types.ASSIGN_SELECTION_DATE_SUCCESS](state, { data }) {
    state.loading = false
    state.resultAssignmentSelectionDate = data
    state.error = null
  },
  [types.ASSIGN_SELECTION_DATE_ERROR](state, { error }) {
    state.loading = false
    state.resultAssignmentSelectionDate = null
    state.error = error
  },
}

export const actions = {
  getNotifications({ commit }, { init, notifications, page }) {
    if (isBooleand(init) && init === true) {
      commit(types.GET_NOTIFICATIONS_START)
    }

    axios.get(`/api/notifications/list?page=${page}`)
      .then(function (response) {
        const { data } = response

        commit(types.GET_NOTIFICATIONS_SUCCESS, { notifications, data: data.data })
      })
      .catch(error => {
        commit(types.GET_NOTIFICATIONS_ERROR, { error })
      })
  },
  getEvent({ commit }, payload) {
    commit(types.GET_EVENT, payload)
  },
  /**
   * @param {Number} payload
   */
  async assignSelectionDate({ commit }, payload) {
    try {
      commit(types.ASSIGN_SELECTION_DATE_START)

      const { data } = await axios.post(`/api/notifications/${payload}/assign_selection_date`)

      commit(types.ASSIGN_SELECTION_DATE_SUCCESS, { data })
    } catch (e) {
      commit(types.ASSIGN_SELECTION_DATE_ERROR, { error: null })
    }
  },
}

// getters
export const getters = {
  // notifications
  loadingNotifications: state => state.loadingNotifications,
  errorNotifications: state => state.errorNotifications,
  notifications: state => state.notifications,

  // new notification
  newNotification: state => state.newNotification,

  // Assignment
  loadingResultAssignmentSelectionDate: state => state.loading,
  resultAssignmentSelectionDate: state => state.resultAssignmentSelectionDate,
  errorResultAssignmentSelectionDate: state => state.error,
}
